import { Injectable, Renderer2, RendererFactory2, DOCUMENT, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { BusinessFrontId, businessFronts } from "./business-front.data";

@Injectable({
  providedIn: "root",
})
export class BusinessFrontService {
  private rendererFactory = inject(RendererFactory2);

  private document = inject<Document>(DOCUMENT);

  readonly current = new BehaviorSubject(businessFronts.vss);

  private renderer: Renderer2;

  constructor() {
    const rendererFactory = this.rendererFactory;

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  getBusinessFront() {
    return this.current;
  }

  setBusinessFront(businessFrontId: BusinessFrontId) {
    this.current.next(businessFronts[businessFrontId]);
    this.renderer.setAttribute(this.document.body, "data-business-front", businessFrontId);
  }
}
